import { Resource } from 'beisheim/models'

class Team extends Resource {
  static entity = 'Team'
  static baseEntity = 'Resource'

  get members () {
    return this.all('members')
  }
}

Resource.addModel(Team)

export { Team }
export default Team
